<template>
  <v-container fluid class="container-page">
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="12"
        class="d-flex text-title-container"
      >
        <div class="text-title text-primary">Grammars</div>
        <v-spacer></v-spacer>
        <v-btn
          id="new-user"
          class="m-auto"
          color="btn-primary"
          @click="dialog = true"
          >New</v-btn
        >
      </v-col>
    </v-row>

    <div>
      <v-data-table
        :loading="loading"
        loading-text="Loading..."
        :headers="headers"
        :items="grammars"
        :sort-by.sync="search.sortBy"
        :sort-desc.sync="search.sortDesc"
        :items-per-page="9999"
        hide-default-footer
        fixed-header
        must-sort
        class="elevation-1"
      >
        <template v-slot:item="props">
          <tr
            :id="`field${props.index}`"
            class="cursor-pointer"
            @click="editItem(props.item)"
          >
            <td>{{ props.item.name }}</td>
            <td>{{ typeName(props.item.type) }}</td>
            <td class="ellipsis">
              <div v-if="props.item.description">
                <v-tooltip max-width="350" top>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      {{ substring(props.item.description) }}
                    </span>
                  </template>
                  <div
                    class="overflow-wrap"
                    v-html="displayTooltip(props.item.description)"
                  ></div>
                </v-tooltip>
              </div>
              <div v-else>{{ substring(props.item.description) }}</div>
            </td>
            <td>{{ props.item.updated_at | datetimeFormat }}</td>
            <td class="text-center">
              <v-icon small @click.stop="deleteItem(props.item)">
                fa-trash
              </v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>

    <dialog-manage
      v-if="dialog"
      :rules="rules"
      :dialog="dialog"
      :editedIndex="editedIndex"
      :editedItem="editedItem"
      :errorMessage="errorMessage"
      :groups="groups"
      @close="close"
      @save="save"
    />

    <dialog-confirm
      v-if="dialogConfirm.open"
      :dialogConfirm="dialogConfirm"
      @dialogConfirmClick="dialogConfirmClick"
    />

    <snackbar v-if="snackbar.open" :snackbar="snackbar" />
  </v-container>
</template>
<script>
import _ from 'lodash'
import apiGrammar from '@/apis/grammar'

import DialogManage from './components/dialog_manage'
import Snackbar from './components/snackbar'
import DialogConfirm from './components/dialog_confirm'

export default {
  name: 'Fields',
  props: {
    rulesCharcacters50: Object
  },
  components: {
    DialogManage,
    Snackbar,
    DialogConfirm
  },
  data() {
    return {
      loading: false,
      search: {
        sortBy: [],
        sortDesc: []
      },
      headers: [
        {
          text: 'Grammar',
          value: 'name',
          sortable: true,
          width: '25%'
        },
        {
          text: 'Grammar type',
          value: 'description',
          sortable: false,
          width: '25%'
        },
        {
          text: 'Description',
          value: 'description',
          sortable: false,
          width: '25%'
        },
        {
          text: 'Last updated',
          value: 'updated_at',
          sortable: false,
          width: '20%'
        },
        {
          text: '',
          value: 'action',
          sortable: false,
          align: 'center',
          width: '5%'
        }
      ],
      grammars: [],
      dialog: false,
      editedIndex: -1,
      editedItem: {
        _id: '',
        name: '',
        description: '',
        type: 'google',
        model: 'command_and_search',
        google: [],
        vxml: '',
        address: '',
        replace_text: '',
        ai_model_name: ''
      },
      defaultItem: {},
      errorMessage: '',
      snackbar: {
        open: false,
        colorSnackbar: '',
        textSnackbar: ''
      },
      dialogConfirm: {
        open: false,
        _id: '',
        name: ''
      },
      groups: []
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  },
  computed: {
    rules() {
      return {
        rulesCharcacters50: this.rulesCharcacters50
      }
    }
  },
  created() {
    document.title = this.$t('page-title.grammars', {
      productName: this.$options.filters.getVariable('product_name')
    })

    this.defaultItem = _.cloneDeep(this.editedItem)

    this.initial()
  },

  methods: {
    async initial() {
      await this.getGrammar()
    },
    async getGrammar() {
      try {
        this.loading = true

        const getGrammar = await apiGrammar.getGrammar()
        const { data } = getGrammar
        this.grammars = data

        setTimeout(() => {
          this.loading = false
        }, 500)
      } catch (error) {}
    },
    editItem(item) {
      this.editedIndex = this.grammars.indexOf(item)

      if (!item.model) item.model = 'command_and_search'
      this.editedItem = _.cloneDeep(item)

      this.errorMessage = ''
      this.dialog = true
    },

    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = _.cloneDeep(this.defaultItem)
        this.editedIndex = -1
      })
      this.errorMessage = ''
    },
    async save() {
      try {
        const re = /^[a-zA-Z0-9_]+$/i

        if (!this.editedItem.name) {
          this.errorMessage = 'Grammar name is required'
          return false
        } else if (
          this.editedItem.name.length < 1 ||
          this.editedItem.name.length > 50
        ) {
          this.errorMessage = 'Grammar name must be 1-50 characters'
          return false
        } else if (!re.test(this.editedItem.name)) {
          this.errorMessage =
            'Grammar name must be alphanumeric ( A-Z, a-z, 0-9, _ )'
          return false
        }

        if (this.editedItem.type === 'google') {
          // const google = _.filter(this.editedItem.google, o => {
          //   return o.str_phrases
          // })
          const google = []
          for (const data of this.editedItem.google) {
            if (data.str_phrases) {
              data.phrases = data.str_phrases
                .split(',')
                .map(item => item.trim())
                .filter(item => item)

              data.str_phrases = undefined

              google.push(data)
            }
          }

          this.editedItem.google = google
        } else if (this.editedItem.type === 'vxml') {
          if (!this.editedItem.vxml) {
            this.errorMessage = 'VXML is required'
            return false
          }
        } else {
          if (!this.editedItem.address) {
            this.errorMessage = 'True Voice ASR server address is required'
            return false
          }
        }

        const obj = {
          name: this.editedItem.name.trim(),
          description: this.editedItem.description,
          type: this.editedItem.type,
          model: undefined,
          google: undefined,
          vxml: undefined,
          address: undefined,
          replace_text: this.editedItem.replace_text,
          ai_model_name: this.editedItem.ai_model_name || ''
        }

        if (this.editedItem.type === 'google') {
          obj.model = this.editedItem.model
          obj.google = this.editedItem.google
        } else if (this.editedItem.type === 'vxml') {
          obj.vxml = this.editedItem.vxml
        } else {
          obj.address = this.editedItem.address
        }

        if (this.editedIndex > -1) {
          const _id = this.editedItem._id

          await apiGrammar.updateGrammar(_id, obj)

          this.snackbar.colorSnackbar = 'success'
          this.snackbar.textSnackbar = 'Changes saved'
          this.snackbar.open = true

          this.getGrammar()
          this.close()
        } else {
          await apiGrammar.createGrammar(obj)

          this.snackbar.colorSnackbar = 'success'
          this.snackbar.textSnackbar = `${this.editedItem.name} created`
          this.snackbar.open = true

          this.getGrammar()
          this.close()
        }
      } catch (error) {
        this.errorMessage = error.message
      }
    },

    deleteItem(item) {
      this.dialogConfirm.open = true

      this.dialogConfirm._id = item._id
      this.dialogConfirm.name = item.name
    },
    async dialogConfirmClick() {
      const deleteGrammar = await apiGrammar.deleteGrammar(
        this.dialogConfirm._id
      )

      if (deleteGrammar.code === 0) {
        this.getGrammar()
        this.close()

        this.snackbar.colorSnackbar = 'error'
        this.snackbar.textSnackbar = `${this.dialogConfirm.name} deleted`
        this.snackbar.open = true

        this.setDefaultDialogConfirm()
      } else {
        this.snackbar.colorSnackbar = 'error'
        this.snackbar.textSnackbar = deleteGrammar.message
        this.snackbar.open = true
      }
    },
    setDefaultDialogConfirm() {
      this.dialogConfirm.open = false

      this.dialogConfirm._id = ''
      this.dialogConfirm.name = ''
    },
    typeName(item) {
      switch (item) {
        case 'vxml':
          return 'VXML'
        case 'true_voice_asr':
          return 'True Voice ASR'
        default:
          return 'Google'
      }
    },
    substring(text) {
      let msg = text
      if (text && text.includes('\n')) {
        const textArr = text.split('\n')
        msg = textArr[0]
      }
      return msg && msg.length > 50 ? `${msg.substring(0, 50)}...` : msg
    },
    displayTooltip(text) {
      let msg = text
      if (text) msg = msg.replace(/\n/gi, '<br>')
      return msg
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-data-table__wrapper {
  height: calc(100vh - 129px);
}

.ellipsis {
  max-width: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
